import { Component, OnInit, ViewChild, HostListener, Output, EventEmitter, Input, SimpleChanges, ChangeDetectorRef, ElementRef } from '@angular/core';
import { MatDialog, MatSidenav, MatTab } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JobService } from '../../services/jobs/job.service';
import { StaffService } from '../../services/staff/staff.service';
import { FilterService } from '../../services/filter.service';
import { SchedulerComponent } from 'src/app/scheduler/scheduler.component';
import { NgSelectConfig } from '@ng-select/ng-select';
import { LocationStrategy, Location } from '@angular/common';
import { TimeSheetService } from 'src/app/services/time-sheet.service';
import { AccidentUserService } from '../../services/accident-user.service';
import { AccidentService } from 'src/app/services/accident.service';
import { UtilityService } from 'src/app/services/utility.service';
import { months } from '../../_models/staticArray'
import { UserTimeSheetService } from '../../services/user-time-sheet.service'
import * as moment from 'moment';
import { SingleWeekComponent } from '../../time-sheet/single-week/single-week.component';
import { UserSingleWeekComponent } from 'src/app/time-sheet/user-single-week/user-single-week.component';
import { CompetenciesService } from '../../services/competencies.service';
import { config } from '../../config';
@Component({
  selector: 'app-single-staff',
  templateUrl: './single-staff.component.html',
  styleUrls: ['./single-staff.component.scss']
})
export class SingleStaffComponent implements OnInit {
  @Output() getFileDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() openCompPanel: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() AccidentLength: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('staffTab', { static: true }) staffTab: MatTab;
  @ViewChild('jobTab', { static: true }) jobTab: MatTab;
  @ViewChild('weekTab', { static: true }) weekTab: MatTab;
  @ViewChild('compTab', { static: true }) compTab: MatTab;
  @ViewChild('accidentTab', { static: true }) accidentTab: MatTab;
  @ViewChild('assetTab', { static: true }) assetTab: MatTab;
  @ViewChild('cpdTab', { static: true }) cpdTab: MatTab;
  @Input('newAddedCompetency') newAddedCompetency: any;

  instructor;
  closeBtnNeeded = true;
  instructorId;
  length;
  currentUser;
  jobs;
  job;
  isAsset: boolean = false
  selectedMonths;
  loading: boolean = false;
  profilePath;
  view;
  mobile;
  email;
  isAccident: boolean = false
  isPrint: boolean;
  file: any;
  compId: any;
  deleteEvent: any;
  user
  deletedUser = false
  module: any;
  updatedInstructor: any;
  monthChangeDates: any;
  datesRanges: any;
  isCpdCalender: boolean = false;
  isClearBtnShow: boolean = false;
  start: any;
  end: any;
  pdfBtnDisable: boolean = false;
  systemDate: any;
  timeSheetData: any
  currentWeekDates = []
  isCalculation: boolean = false
  tabIndex
  baseURL = config.baseApiUrl
  @HostListener('window:beforeprint', ['$event'])
  onBeforePrint(event) {
    this.isPrint = true;
    $('.mat-tab-header').hide()
  }
  @HostListener('window:afterprint', ['$event'])
  onAfterPrint(event) {
    this.isPrint = false
    $('.mat-tab-header').show()
  }
  appHideMe: boolean = false
  displayColumns: any[] = ['Copy', 'Week Number', 'Week Start', 'Week End', 'Hours Worked', 'Details of CPD Complete', 'Reflection', 'Total Files', 'Reset', 'Edit']
  displayedColumns: string[] = ['sr.no', 'client', 'location', 'instructor', 'course', 'actions']
  jobForScheduler: any;
  dateOfJoining: any;
  months = months
  datesRange;
  allWeeks: any[];
  selectedWeeks: any;
  doCalWeekDates = true;
  weekDates: unknown;
  monthChanged: boolean;
  selectedTab = 0
  isCompetencies: boolean = false
  isWeekSummary: boolean = false
  selectedInstructorId
  selectedInstructors
  weekDatesArr: any = []
  selected = { 'start': moment(), 'end': moment() }
  yearList = []
  selectedYear
  currentYear
  assetURL
  allYearweekList = []
  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;
  @ViewChild(UserSingleWeekComponent, { static: false }) timeSheet: UserSingleWeekComponent;
  @ViewChild(SingleWeekComponent, { static: false }) weekSheet: SingleWeekComponent;

  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _filter: FilterService,
    public _staffService: StaffService,
    public _jobService: JobService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public _accidentSerives: AccidentService,
    private configData: NgSelectConfig,
    private location: Location,
    private locationStrategy: LocationStrategy,
    private _timeSheetService: TimeSheetService,
    public accidentUserService: AccidentUserService,
    public _utilityService: UtilityService,
    public userTimeSheetService: UserTimeSheetService,
    private el: ElementRef,
    public _cd: ChangeDetectorRef,
    public _competencyService: CompetenciesService
  ) {

    this.activatedRoute.params.subscribe(params => {
      this.instructorId = params.id;
    });
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.configData.notFoundText = 'Please select a month to display dates';
    this.userTimeSheetService.pdfDownloadCompleted().subscribe((data) => {
      console.log("this is the data when download is done", data);
      this.pdfBtnDisable = false
    })
  }

  async ngOnInit() {
    this.module = JSON.parse(localStorage.getItem('module'))
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.loading = true
    this.activatedRoute.queryParams.subscribe(qparams => {
      if (qparams && qparams.accidentType && qparams.userRole) {
        let obj = {
          userRole: qparams.userRole,
          accidentType: qparams.accidentType,
          userId: qparams.userId,
          accidentId: qparams.accidentId,
          userForm: qparams.userForm,
          currentTab: 0
        }
        this.accidentTab.disabled = false
        this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: obj });
      }
      else if (qparams && qparams.accidentType && !qparams['currentTab']) {
        console.log("in IF qparams['currentTab']", qparams['currentTab'])
        let event = {
          index: 0
        }
        this.accidentTab.disabled = true
      }
      else if (qparams && !qparams.accidentType && !qparams.userRole) {
        console.log("call this else part", qparams);
        this.selectedTab = qparams['currentTab']
      }
    })
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.getInstructor(this.instructorId);
    // this.getCurrentWeekDates()
    await this._timeSheetService.getYearList().then((yearData: { currentYear: Number, yearList: [], systemDate: '' }) => {
      console.log("CURRENT DATE IN SERVICE", yearData)
      this.yearList = yearData.yearList
      this.currentYear = yearData.currentYear
      this.selectedYear = this.currentYear
      this.systemDate = yearData.systemDate
      this.getCurrentMonthWeeks()
      this.getAllYearWeeks()
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("***changes", changes);
    if (changes)
      this.getCurrentMonthWeeks()
  }

  // UTILITY

  checkUserRole() {
    let userRole = this.instructor.userId.userRole
    if (this.instructor && this.instructor.isDelete == true) this.deletedUser = true

    // if (this.instructor.userId.userRole && this.instructor.userId.userRole.length && this.instructor.userId.userRole.includes('IQA') || this.instructor.userId.userRole.includes('trainer')) this.isCpdCalender = true, this.cpdTab.disabled = false
    // else this.isCpdCalender = false, this.cpdTab.disabled = true

    if (this.currentUser.userRole.includes('admin')) {
      if (userRole.includes('mp') || userRole.includes('trainer') || userRole.includes('IQA') || userRole.includes('client') || userRole.includes('operative') || (this.instructor && this.instructor.competencies && this.instructor.competencies.length)) this.isCompetencies = true, this.compTab.disabled = false
      else this.isCompetencies = false, this.compTab.disabled = true
    } else if (userRole.includes('mp') || userRole.includes('trainer') || userRole.includes('IQA') || userRole.includes('client') || userRole.includes('operative') || (this.instructor && this.instructor.competencies && this.instructor.competencies.length)) this.isCompetencies = true, this.compTab.disabled = false
    else this.isCompetencies = false, this.compTab.disabled = true

    if (this.currentUser.userRole.includes('admin')) {
      if ((userRole.includes('mp') || userRole.includes('trainer') || userRole.includes('IQA') || userRole.includes('operative') || userRole.includes('client')) && this.module && this.module.isTimesheet) this.isWeekSummary = true, this.weekTab.disabled = false
      else this.isWeekSummary = false, this.weekTab.disabled = true
    } else if ((userRole.includes('mp') || userRole.includes('trainer') || userRole.includes('IQA') || userRole.includes('operative') || userRole.includes('client')) && this.module && this.module.isTimesheet) this.isWeekSummary = true, this.weekTab.disabled = false
    else this.isWeekSummary = false, this.weekTab.disabled = true

    if (this.currentUser.userRole.includes('admin')) {
      if (userRole.includes('incidentUser')) this.isAccident = true, this.accidentTab.disabled = false
      else this.isAccident = false, this.accidentTab.disabled = true
    } else if (userRole.includes('incidentUser')) this.isAccident = true, this.accidentTab.disabled = false
    else this.isAccident = false, this.accidentTab.disabled = true

    // if ((this.user && (this.user.isTrainer || this.user.isMp || this.user.isIQA || this.user.isAdmin)) && (this.instructor && (this.instructor.userId.userRole && this.instructor.userId.userRole.length)) && (this.isWeekSummary || this.isCompetencies)) this.jobTab.disabled = false
    // else this.jobTab.disabled = true
  }

  eventFromAccidentTab(event) {
    console.log("here is accident Tab Flag check", event)
    this.isAccident = event.isAccident;
    this._accidentSerives.displayAccidentTab({ isAccident: event.isAccident })

  }

  changeProfile(event) {
    console.log("when profile change", event, this.instructor);
    const data = new FormData();
    data.append('profile', event);
    data.append('user', this.instructor._id);
    data.append('isPolicy', this.instructor.userId.passwordPolicy)
    const userRole = this.instructor.userId.userRole
    if (userRole.includes('mp') || userRole.includes('trainer') || userRole.includes('IQA') || userRole.includes('operative')) {
      this._staffService.updateProfilePhoto(data).subscribe((response) => {
        console.log("response of file upload", response);
        this._utilityService.handleSnackBar({ msg: "Profile updated successfully!", button: "OK" })
      }, error => {
        console.log("error", error);
      })
    } else {
      this.accidentUserService.uploadProfilePhoto(data).subscribe((response) => {
        console.log("response of profile photo update", response);
      }, err => {
        console.log("err ", err);
      })
    }
  }

  updatedData(event) {
    this.updatedInstructor = event.data
  }

  scheduler() {
    console.log("JOB found in scheculer", this.jobs);
    this.jobForScheduler = this.jobs;
    let dialogRefScheduler = this.dialog.open(SchedulerComponent, {
      data: this.jobForScheduler,
      panelClass: 'customScheduler',
      width: '100%',
      height: '100vh'
    })
  }

  generateMonthWeeks() {
    // this.selectedWeeks = []
    // this.monthChanged = true
    // console.log("CALL THIS MAIN FUNCTION", this.selectedWeeks)
    // this._timeSheetService.calculateMonthWeeks(this.selectedMonths, this.selectedYear).then((res: any) => {
    //   console.log("What is the res of selected month", res);

    //   this.allWeeks = res.allweeks
    //   this.datesRange = res.datesRange
    //   this.weekDates = res.datesRange
    // }).catch((err) => {
    //   console.log('err', err)
    // })

    this.selectedWeeks = []
    this.monthChanged = true
    console.log("CALL THIS MAIN FUNCTION", this.selectedWeeks, this.selectedMonths, this.selectedYear)
    console.log("ALL WEEK YEAR LIST", this.allYearweekList)
    let monthWeeks = []
    if (this.selectedMonths !== undefined) {
      this.allYearweekList.filter((x) => {
        //  console.log("WHAT IS THE X", x)
        if ((Number(x.month) === (Number(this.selectedMonths.id) + 1)) && (Number(x.year) === Number(this.selectedYear))) {
          console.log("THIS IS THE SELECTED MONTH WEEK", x)
          let obj = {
            weekNumber: x.weekNumber, weekStartDate: x.startDate, weekEndDate: x.endDate,
            from: moment(x.startDate).format('DD/MM/YYYY'),
            to: moment(x.endDate).format('DD/MM/YYYY'),
            bothDates: "From: " + moment(x.startDate).format('DD/MM/YYYY') + " - " + "To: " + moment(x.endDate).format('DD/MM/YYYY'),
            dateList: x.dateList
          }
          monthWeeks.push(obj)
          // x
        }
      })
      this.datesRange = monthWeeks
      console.log("MONTH WEEK", this.datesRange)
    }
  }

  generateWeekDates() {
    this.monthChanged = false
    // this._timeSheetService.generateWeekDates(this.selectedWeeks).then((res: any) => {
    //   this.doCalWeekDates = false
    //   console.log("What is the res of selected month", res.weekDates)
    //   this.weekDates = res.weekDates
    //   this.weekDatesArr = res.weekDates
    // }).catch((err) => {
    //   this.doCalWeekDates = false
    // })
    this.weekDates = this.selectedWeeks.dateList
    this.weekDatesArr = this.selectedWeeks.dateList
    // console.log("**generatingWeekDates", this.selectedWeeks.datelist, this.weekDatesArr);

  }

  clearMonth() {
    this.doCalWeekDates = true
    this.selectedWeeks = []
    this.datesRange = []
    this.getCurrentWeekDates()
  }

  clearWeek() {
    this.doCalWeekDates = true
    this.selectedWeeks = []
    this.datesRange = []
    this.selectedMonths = []
    this.getCurrentWeekDates()
  }

  closeYearSelection() {
    // this.doCalWeekDates = true
    this.selectedWeeks = []
    // this.datesRange = []
    this.selectedMonths = []
    // this.getCurrentWeekDates()
  }

  datesSelected(event) {
    console.log("When date rang close", event);

    this.isClearBtnShow = false
    let d1 = event.startDate
    let d2 = event.endDate
    if (d1 != null || d2 != null) {
      this.isClearBtnShow = true
      this._timeSheetService.filterDates(event.startDate, event.endDate, this.systemDate).then((response: any) => {
        console.log("Response of dates", response);

        this.monthChangeDates = response.datesRange
      }, err => {
        console.log("err", err);
      })
    } else {
      let d = new Date(this.systemDate);
      const n = this.months[d.getMonth()];
      console.log('this is the current month ', [n])
      this._timeSheetService.generateMonthWeeks(n, this.selectedYear).then((res: any) => {
        console.log("res in get current week", res);
        this.allWeeks = res.allWeeks
        let n = this.allWeeks.length
        this.selected = { 'start': moment(this.allWeeks[0].from), 'end': moment(this.allWeeks[n - 1].to) }
        this.monthChangeDates = res.datesRange
      }).catch((err) => {
        console.log('err', err)
      })
    }
  }

  fileDetails(event) {
    // this.getFileDetails.emit(event)
    // this.openCompPanel.emit(event)
    this._competencyService.openCompetencyFile(event)
    console.log("getFileDetails event emitted from single-instructor", event);
  }

  deleteFile(event) {
    this.deleteEvent = event
    this.mydsidenav.close()
  }

  assetValidation(event) {
    this.isAsset = event.isAsset;
    if (this.isAsset == true)
      this.assetTab.disabled = false
    else this.assetTab.disabled = true
  }
  changeParams(event) {
    console.log("WHAT IS THE EVENT", event, this.datesRanges);

    let cTab = event.index
    if (cTab == 4) {
      if (this.isAsset || this.isAccident) cTab = 4
    }
    if (cTab == 5) {
      if (this.isAccident) cTab = 5
      else cTab = 4
    }
    if (cTab == 6) {
      if (this.isAsset && this.isAccident) cTab = 6
      else if (this.isAccident || this.isAsset) cTab = 5
      else cTab = 4
    }
    this.location.go(
      this.router.createUrlTree(
        [this.locationStrategy.path().split('?')[0]], // Get uri
        { relativeTo: this.activatedRoute, queryParams: { currentTab: cTab } }).toString()
    );
    this.closeFilesSideNav.emit('close')
  }

  checkedData() {
    this.pdfBtnDisable = true
  }


  downloadQRcode(parent) {
    let qrImage = document.getElementsByTagName('canvas')[0]
    let finalTest = this.trimCanvas(qrImage)
    let blobData = this.convertBase64ToBlob(finalTest);
    const blob = new Blob([blobData], { type: "image/png" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.instructor.name + '-QR';
    link.click();
  }


  trimCanvas(c) {
    let ctx = c.getContext('2d'),
      copy = document.createElement('canvas').getContext('2d'),
      pixels = ctx.getImageData(0, 0, c.width, c.height),
      l = pixels.data.length,
      i,
      bound = {
        top: null,
        left: null,
        right: null,
        bottom: null
      },
      x, y;

    // Iterate over every pixel to find the highest
    // and where it ends on every axis ()
    for (i = 0; i < l; i += 4) {
      if (pixels.data[i + 3] !== 0) {
        x = (i / 4) % c.width;
        y = ~~((i / 4) / c.width);

        if (bound.top === null) {
          bound.top = y;
        }

        if (bound.left === null) {
          bound.left = x;
        } else if (x < bound.left) {
          bound.left = x;
        }

        if (bound.right === null) {
          bound.right = x;
        } else if (bound.right < x) {
          bound.right = x;
        }

        if (bound.bottom === null) {
          bound.bottom = y;
        } else if (bound.bottom < y) {
          bound.bottom = y;
        }
      }
    }

    // Calculate the height and width of the content
    let trimHeight = bound.bottom - bound.top,
      trimWidth = bound.right - bound.left,
      trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);
    console.log("trimmed", trimmed)
    //  this.testdata = trimmed.data
    copy.canvas.width = trimWidth;
    copy.canvas.height = trimHeight;
    copy.putImageData(trimmed, 0, 0);

    // Return trimmed canvas
    console.log('copy.canvas;', copy.canvas.toDataURL())
    console.log(" copy.putImageData(trimmed, 0, 0);", copy.putImageData(trimmed, 0, 0))
    // this.testdata = copy.canvas.toDataURL()
    return copy.canvas.toDataURL();
  }

  private convertBase64ToBlob(Base64Image: any) {
    // SPLIT INTO TWO PARTS
    const parts = Base64Image.split(';base64,');
    // HOLD THE CONTENT TYPE
    const imageType = parts[0].split(':')[1];
    // DECODE BASE64 STRING
    const decodedData = window.atob(parts[1]);
    // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
    const uInt8Array = new Uint8Array(decodedData.length);
    // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // RETURN BLOB IMAGE AFTER CONVERSION
    return new Blob([uInt8Array], { type: imageType });
  }


  redirectPage() {
    console.log("STAFF USER DATA", this.instructor)
    let url = config.clientUrl + 'digital-card/' + this.instructor._id + '?isDigital=true'
    window.open(url)
    // http://localhost:4200/staff/view/63a14115a11abb6c88610903  
    // this.router.navigate(['digital-card/' + this.instructor._id])
  }

  // API CALL



  getCurrentWeekDates() {
    // this._timeSheetService.getSystemDate().subscribe(date => {
    //   console.log('system Date', date)

    //   let today = new Date(date.systemDate);
    //   this._timeSheetService.getCurrentWeekDates(today).then((res: any) => {
    //     if (res == undefined) return
    //     else {
    //       this.currentWeekDates = res.weekDates
    //       this.selectedYear = this.currentYear
    //       console.log("this.datesRange", res);
    //       // this.selected = { 'start': moment(this.datesRanges[0]), 'end': moment(this.datesRanges[this.datesRanges.length - 1]) }
    //     }
    //   })
    // })
    let obj = {
      _isWeek: true,
      selectedUser: this.selectedInstructors._id
    }
    this._timeSheetService.getRailWeekDates(obj).subscribe((data) => {
      this.currentWeekDates = data[0].dateList
      this.selectedYear = this.currentYear
    }, error => {
      console.log("ERROR WHILE GETTING CURRENT WEEK DATES", error)
    })
  }

  getInstructor(instructorId) {
    this.loading = true
    this._staffService.getInstructorById(instructorId).subscribe((res => {
      this.assetURL = config.clientUrl + 'digital-card/' + this.instructorId + '?isDigital=true&type=instructor'
      this.instructor = res[0];
      this.selectedInstructors = this.instructor
      this.selectedInstructorId = this.instructor._id
      this.getCurrentWeekDates()
      this.checkUserRole()
      this._cd.detectChanges()
      this.profilePath = this.instructor.profilePic;
      this.mobile = this.instructor.mobile;
      this.email = this.instructor.email;
      this.dateOfJoining = new Date(this.instructor.dateOfJoining);
      this.loading = false
    }))
  }



  public fatigueIndexCalculation() {
    console.log("current selected user", this.selectedInstructors);
    const data = {
      userId: this.selectedInstructors.userId._id,
      type: 'fatigue'
    }
    console.log("this is the data to be send", data);
    this.userTimeSheetService.getFatigueIndex(JSON.stringify(data)).subscribe((response) => {
      console.log("response of fatigue index", response);
      this.isCalculation = true
    }, err => {
      console.log("error while get fatigue index", err);
    })
  }


  getCurrentMonthWeeks() {
    // this._timeSheetService.getSystemDate().subscribe(date => {
    // this.systemDate = date.systemDate
    let d = new Date(this.systemDate);
    const n = this.months[d.getMonth()];
    this._timeSheetService.generateMonthWeeks(n, this.selectedYear).then((res: any) => {
      this.allWeeks = res.allWeeks
      this.datesRanges = res.datesRange
      console.log("What is the date range data", this.datesRanges);

      let n = this.allWeeks.length
      this.selected = { 'start': moment(this.allWeeks[0].from), 'end': moment(this.allWeeks[n - 1].to) }
    }).catch((err) => {
      console.log('err', err)
    })
    // })
  }
  getAllYearWeeks() {

    this._timeSheetService.getRailWeekDates({}).subscribe((weekList) => {
      // this.allWeeks = weekList
      this.allYearweekList = weekList
      console.log("ALL WEEK LIST OF SELECTED YEAR", weekList)
    }, error => {
      console.log("error while get week list", error);
    })
  }
}
